import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

export default function EmailInvoiceModal({
  show,
  onHide,
  defaultEmail,
  onSend,
}) {
  const [email, setEmail] = useState(defaultEmail || "");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  // reset local state whenever the modal opens
  useEffect(() => {
    if (show) {
      setEmail(defaultEmail || "");
      setError("");
      setSending(false);
    }
  }, [show, defaultEmail]);

  const handleSubmit = () => {
    // 1) basic validation
    if (!email) {
      setError("Email is required");
      return;
    }

    // 2) close the modal immediately
    onHide();

    // 3) show spinner on the button behind the scenes
    setSending(true);
    setError("");

    // 4) fire-and-forget the send
    onSend(email)
      .catch((err) => {
        console.error("Failed to send invoice:", err);
        // Optionally you could trigger a toast or dispatch an error-notification
        setError("Failed to send invoice");
      })
      .finally(() => {
        setSending(false);
      });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Send Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form>
          <Form.Group controlId="invoiceEmail">
            <Form.Label>Recipient Email Address</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter recipient email"
              isInvalid={!!error}
            />
            <Form.Control.Feedback type="invalid">
              {error}
            </Form.Control.Feedback>
          </Form.Group>
          <p className="mt-2 ms-1">The invoice will be sent as a PDF attachment to the email address above. You will be notified once it has been sent.</p>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={sending}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={sending}>
          {sending ? "Sending..." : "Send"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
